import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import OurTreatment from "./OurTreatment";
import Gallery from "./Gallery";
import Testimonials from "./Testimonials";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import Account from "./Account"
import AppointmentDetail from "./AppointmentDetail";
import MyRemedies from "./MyRemedies";
import TermAndCondition from "./TermAndCondition";
import PrivacyPolicy from "./PrivacyPolicy";
import ForgotPassword from "./ForgotPassword";
import PaymentSuccess from "./PaymentSuccess";
import PaymentFailed from "./PaymentFailed";
import Payment from "./Payment";
const Content = () => {
 
  return (
    <div style={{ width: "100%", margin: "auto",}}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ourtreatment" element={<OurTreatment />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/teams" element={<Testimonials />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/account" element={<Account />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/myappointment" element={<AppointmentDetail />} />
        <Route path="/myremedies" element={<MyRemedies />} />
        <Route path="/termandcondition" element={<TermAndCondition />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/paymentsuccess" element={<PaymentSuccess />} />
        <Route path="/paymentfail" element={<PaymentFailed />} />
        <Route path="/payment" element={<Payment />} />
      </Routes>
    </div>
  );
};

export default Content;